export type AppTab =
  | "home"
  | "wallets"
  | "shops"
  | "oracle"
  | "pay"
  | "market"
  | "trade"
  | "auth"
  | "inbox";

export const TAB_TITLES: Record<AppTab, string> = {
  home: "خانه",
  wallets: "کیف پول",
  shops: "فروشگاه‌ها",
  oracle: "استخر",
  pay: "پرداخت",
  market: "بازار",
  trade: "معامله",
  auth: "ورود",
  inbox: "صندوق",
};

/** Wallex primary: Home · Market · Trade · Wallet — Nanom extras via Home grid */
export const MOBILE_NAV: { id: AppTab; label: string; ico: string }[] = [
  { id: "home", label: "خانه", ico: "⌂" },
  { id: "market", label: "بازار", ico: "◈" },
  { id: "trade", label: "معامله", ico: "⇄" },
  { id: "wallets", label: "کیف‌پول", ico: "◇" },
];
